import { RefundProtectQuoteResponse } from 'api/insurance'

export function bookingProtectionQuoteMap(payload: RefundProtectQuoteResponse['result']): App.BookingProtectionQuote {
  return {
    quoteId: payload.quoteId,
    products: payload.products.map(product => ({
      productPrice: product.productPrice,
    })),
  }
}
